import React from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import { toast } from 'react-toastify';
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import TapSelect from '../../../components/ui/TapSelect';
import { Helmet } from 'react-helmet';
import { Modal } from 'bootstrap';
import { Link } from 'react-router-dom';
import download from '../../../services/DownloadFile'
import moment from 'moment';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import AppBaseComponent from '../../../components/AppBaseComponent';
import InputVendorSearch from '../../includes/ui/InputVendorSearch';
import ItemViewInList from '../includes/ItemViewInList';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ConsumptionHistoryModal from '../consumption/ConsumptionHistoryModal';
import POHistoryModal from './POHistoryModal';
import ItemTransactionLedger from '../includes/ItemTransactionLedger';
import RequisitionDetailModal from '../requisition/RequisitionDetailModal';
import VendorDetailModal from '../../groupData/vendor/VendorDetailModal';
import NumberFormatter from '../../../services/NumberFormater';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import LogisticViewModal from '../logistic/LogisticViewModal';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import DateService from '../../../services/DateService';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import InputProjectSearch from '../../includes/ui/InputProjectSearch';
import DownloadFile from '../../../services/DownloadFile';
import PurchaseOrderDocument from './PurchaseOrderDocument';
import TapHelper from '../../../services/TapHelper';
import {
    setPOListState,
    clearPOListState
} from '../../../store/actions/poListActions';
import HistoryDataModal from '../HistoryDataModal';
import PurchaseOrderDetailModal from './PurchaseOrderDetailModal';

class PurchaseOrderList extends AppBaseComponent {

    constructor(props) {
        super(props);
        
        this.initPOSearchForm      =       {
            tagged_user_filter              :   '',
            search_transaction_id           :   '',
            search_vendor_ids               :   [],
            search_warehouse_ids            :   [],
            search_purchase_order_type      :   '',
            date_range                      :   null,
            date_range_start                :   null,
            date_range_end                  :   null,
            search_item_ids                 :   [],
            search_item_tags                :   [],
            search_status_ids               :   [],
            search_priority                 :   '',
            search_approved_aging           :   '',
            search_voucher_aging            :   '',
            search_release_aging            :   '',
            tagged_user_ids                 :   [],
            search_ticket_ids               :   [],
            search_project_ids              :   [],
        }

        this.poSearchFormLabel       =       {
            tagged_user_filter              :   'User Tagging : ',
            search_transaction_id           :   'Transaction ID : ',
            search_warehouse_ids            :   'Warehouses : ',
            search_purchase_order_type      :   'Purchase Order Type : ',
            date_range                      :   'Date Range : ',
            search_item_ids                 :   'Items : ',
            search_item_tags                :   'Item Tags : ',
            search_status_ids               :   'Search Status : ',
            search_priority                 :   'Search Priority : ',
            search_vendor_ids               :   'Vendor : ',
            search_approved_aging           :   'Approval Ageing : ',
            search_voucher_aging            :   'Voucher Ageing : ',
            search_release_aging            :   'Released Ageing : ',
            tagged_user_ids                 :   'Tagged Users : ',
            search_ticket_ids               :   "Tickets : ",
            search_project_ids               :   "Project : ",
        }

        this.updateCommentFormInit            =        {
            status                            :         '',
            notes                             :         '',
        }

        this.cancelItemFormInit               =       {
            notes                             :       '',
        }

        this.state                         =     {
            minimizeTable                       :   false,
            listing_loading                     :   false,
            listing_tbl_page                    :   1,
            po_listing                          :   [],
            listingMeta                         :   null,
            totalListingCount                   :   0,
            allItemTags                         :   [],
            poSearchForm                        :   {...this.initPOSearchForm},
            submittedPOFilterForm               :   {...this.initPOSearchForm},
            addCommentForm                      :   {...this.updateCommentFormInit},
            cancelledItemForm                   :   {...this.cancelItemFormInit},
            poSearchFormDataLoaded              :   false,
            all_warehouses                      :   [],
            all_periods                         :   [],
            searchedItem                        :   [],
            formSearchedElems                   :   [],
            searchedVendor                      :   [],
            poTransactionId                     :   null,
            detail_loading                      :   false,
            poDetail                            :   null,
            allStatusOptions                    :   [],
            allPriorityOptions                  :   [],
            allAllowedStatus                    :   [],
            addCommentFormSubmitting            :   false,
            pdfDownloading                      :   false,
            cancelledItemList                   :   [],
            cancel_item_loading                 :   false,
            disableCancelItem                   :   true,
            cancelItemFormSubmitting            :   false,
            itemDetails                         :   null,
            allPOTypes                          :   [],
            searchedProjects                :   [],

            userFilters                         :   [
                {value  :   'tagged_me',        label : 'My Tagged PO'},
                {value  :   'created_by_me',    label : 'PO Created By Me'},
            ],
            allUsers                            :   [],
            searchedTickets                     :   [],  
            criteriaHeight              :            0 ,

        };
        this.criteriaRef                =   React.createRef();
        this.myRef                      =   React.createRef();
        this.poDetailModalRef = React.createRef();

        this.isSavingToRedux = false;
        this.shouldRefreshList = false;


        this.purchaseOrderUrl           =   INVENTORY_API_BASE_URL_2 + '/purchase_order';
        this.searchFormDataUrl          =   this.purchaseOrderUrl + '/search_form_data';
        this.poReportUrl                =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-purchase-order';
        this.projectUrl                 =   IAM_API_BASE_URL_2 + "/project/detail/_replace_id";
        
    }

    getActivePOTransactionId = () => {
        return this.state.poTransactionId || this.state.poDetail?.transaction_id || this.props?.match?.params?.transaction_id || null;
    }

    componentDidMount() {
            console.log("componentDidMount");
        this.poSearchModal = new Modal(document.getElementById('poSearchModal'), {
            keyboard: false,
            backdrop: false
        });

        // Restore from Redux if available or handle refresh/transaction param
        const reduxState = this.props.purchaseOrderListState;
        const hasTransactionParam = this.props?.match?.params?.transaction_id;
        const shouldRefresh = this.props.location?.state?.refresh || this.props.location?.state?.fromAdd || this.shouldRefreshList;
        const shouldPreserveList = hasTransactionParam || this.props?.location?.state?.skipListingReload || this.props?.location?.state?.preserveListState;

        if (shouldRefresh) {
            // Coming from Add/Edit - force refresh
            this.shouldRefreshList = false;
            try { this.props.history.replace('/purchase_order_list', {}); } catch (e) {}
            this.setState({ minimizeTable: false }, () => {
                this.loadListingTblData(1);
            });
            return;
        }

        if (shouldPreserveList && reduxState && reduxState.hasLoaded && reduxState.po_listing && reduxState.po_listing.length > 0) {
            // Restore saved listing and UI state
            this.setState({
                minimizeTable: hasTransactionParam ? true : false,
                poTransactionId: hasTransactionParam || null,
                po_listing: reduxState.po_listing || [],
                listingMeta: reduxState.listingMeta,
                listing_tbl_page: reduxState.listing_tbl_page || 1,
                poSearchForm: reduxState.poSearchForm || { ...this.initPOSearchForm },
                submittedPOFilterForm: reduxState.submittedPOFilterForm || { ...this.initPOSearchForm },
                formSearchedElems: reduxState.formSearchedElems || [],
                searchedVendor: reduxState.searchedVendor || [],
                searchedItem: reduxState.searchedItem || [],
                criteriaHeight: reduxState.criteriaHeight || 0,
                listing_loading: false,
                detail_loading: false,
                all_warehouses: reduxState.all_warehouses || [],
                all_periods: reduxState.all_periods || [],
                allStatusOptions: reduxState.allStatusOptions || [],
                isc_configuration: reduxState.isc_configuration || {},
            }, () => {
                if (hasTransactionParam && this.poDetailModalRef.current) {
                    this.poDetailModalRef.current.getPODetail(hasTransactionParam);
                }
            });
            return;
        }

        // Check if there's a transaction_id in URL params (fallback when no redux restore)
        const { transaction_id } = this.props.match.params;
        if (transaction_id) {
            this.setState({
                poTransactionId: transaction_id,
                minimizeTable: true
            }, () => {
                // Deep-link fallback: fetch listing when no redux cache is available.
                this.loadListingTblData(1);
            });
            if (this.poDetailModalRef.current) {
                this.poDetailModalRef.current.getPODetail(transaction_id);
            }
        } else {
            this.setState({ minimizeTable: false });
            this.handleSearchParams();
        }
    }
    componentWillUnmount() {
    console.log("PurchaseOrderList UNMOUNT");
}

    handleSearchParams = () => {
        console.log("handleSearchParams");
        // If navigation included a request to skip listing reload (e.g. navigating to detail), clear and skip
        if (this.props.location && this.props.location.state && this.props.location.state.skipListingReload) {
            try {
                this.props.history.replace(this.props.location.pathname, {});
            } catch (e) {}
            console.log('handleSearchParams: skipping due to skipListingReload flag');
            return;
        }

        const { search } = this.props.location;
        const searchParams = new URLSearchParams(search);
        const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));

        if (searchText) {
            this.setState(prevState => ({
                poSearchForm: {
                    ...prevState.poSearchForm,
                    search_transaction_id: searchText
                }
            }), () => {
                this.submitPOSearchForm();
            });
        } else {
            this.getPOSearchFormData();

            let ParamObject = new URLSearchParams(this.props.location.search);
            if (ParamObject.get('search_status_ids') || ParamObject.get('search_voucher_ageing') || ParamObject.get('search_approval_ageing') || this.props.location && this.props.location.state && this.props.location.state.vendorPOData || ParamObject.get('search_project_ids')) {
                this.initializeData(this.props)
            } else if (ParamObject.get('transaction_id')) {
                this.setState({
                    poSearchForm: {
                        ...this.state.poSearchForm,
                        search_transaction_id: ParamObject.get('transaction_id')
                    }
                }, () => {
                    this.submitPOSearchForm();
                })
            }
            else {
                this.loadListingTblData(1);
                this.initializeData(this.props)
            }

            if (ParamObject.get('id')) {
                let id = ParamObject.get('id')
                this.viewPODetail(id)
            }
        }
    }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };

    restorePOListFromRedux = () => {
        const reduxState = this.props.purchaseOrderListState;

        if (reduxState && reduxState.hasLoaded && reduxState.po_listing && reduxState.po_listing.length > 0) {
            this.setState({
                minimizeTable: false,
                poTransactionId: null,
                detail_loading: false,
                po_listing: reduxState.po_listing,
                listingMeta: reduxState.listingMeta,
                listing_tbl_page: reduxState.listing_tbl_page || 1,
                poSearchForm: reduxState.poSearchForm || { ...this.initPOSearchForm },
                submittedPOFilterForm: reduxState.submittedPOFilterForm || { ...this.initPOSearchForm },
                formSearchedElems: reduxState.formSearchedElems || [],
                searchedVendor: reduxState.searchedVendor || [],
                searchedItem: reduxState.searchedItem || [],
                criteriaHeight: reduxState.criteriaHeight || 0,
                listing_loading: false,
                all_warehouses: reduxState.all_warehouses || [],
                all_periods: reduxState.all_periods || [],
                allStatusOptions: reduxState.allStatusOptions || [],
                isc_configuration: reduxState.isc_configuration || {},
            });

            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps, prevState) {
            console.log("componentDidUpdate");

        const prevTransactionId = prevProps.match.params.transaction_id;
        const currentTransactionId = this.props.match.params.transaction_id;

        if (currentTransactionId !== prevTransactionId) {
            // Navigated to detail view
            if (currentTransactionId) {
                this.setState({
                    poTransactionId: currentTransactionId,
                    minimizeTable: true
                });
                if (!this.state.po_listing || this.state.po_listing.length === 0) {
                    this.loadListingTblData(1);
                }
                if (this.poDetailModalRef.current) {
                    this.poDetailModalRef.current.getPODetail(currentTransactionId);
                }
            } else {
                // Navigated back to list from detail
                const shouldRefresh = this.props.location?.state?.refresh || this.props.location?.state?.fromAdd || this.shouldRefreshList;
                if (shouldRefresh) {
                    console.log('Force refresh of PO listing after Add/Edit');
                    this.shouldRefreshList = false;
                    this.props.history.replace('/purchase_order_list', {});
                    this.setState({ minimizeTable: false, listing_loading: true }, () => {
                        this.loadListingTblData(1);
                    });
                } else {
                    if (!this.restorePOListFromRedux()) {
                        this.loadListingTblData(1);
                    }
                }
            }
        }

        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000)
        }
        if (this.props.location.search !== prevProps.location.search) {
            this.handleSearchParams();
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.all_periods !== this.props.all_periods) {
            this.initializeData(nextProps)
         }     
    }

    initializeData     =      (pr)      =>      {
        if(pr){
            let all_periods             =       [...pr.all_periods , {key : 'custom' , display : 'Custom Date Range'}] ;
            this.setState({
                all_warehouses          :        pr.all_warehouses ? pr.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}) : [] ,
                all_periods             :        all_periods ,
                allItemTags             :        pr.item_tags && pr.item_tags.length > 0 ? pr.item_tags.map((s) => { return {value: s.id, label: s.name}; }) : [],
            });
        }
     
        if(pr.location && pr.location.state && pr.location.state.poId){
             this.viewPODetail(pr.location.state.poId)
         }

         if(pr.location && pr.location.state && pr.location.state.vendorPOData){
            let vendorPOData    =   pr.location.state.vendorPOData;
            let vendor         =   pr.location.state.vendorPOData.vendor;
            let updateFilterForm = {};
            let warehouse        =  pr.all_warehouses.find(us => us.id == vendorPOData.warehouse_id);
                if (warehouse) {
                    updateFilterForm['search_warehouse_ids'] = [warehouse.id];
                }
                updateFilterForm['search_vendor_ids'] = [vendor.id];
                updateFilterForm['date_range'] = vendorPOData.period;
                setTimeout(() => {
                    this.setState({
                        poSearchForm  : { ...this.state.poSearchForm, ...updateFilterForm},  
                        searchedVendor : [{value : vendor.id,label:vendor.name,display_label : vendor.name} ]                   
                    },
                        function () {
                            this.submitPOSearchForm();
                        });
                }, 1000)
        }

         let ParamObject                 =       new URLSearchParams(pr.location.search);
      
           if(ParamObject.get('search_voucher_ageing') || ParamObject.get('search_approval_ageing')|| ParamObject.get('search_released_ageing') ){
            let  status_ids  =  ParamObject.get('search_status_ids').split(',').map(Number);
            let updateFilterForm        =   {
                    search_voucher_aging : ParamObject.get('search_voucher_ageing') ?  ParamObject.get('search_voucher_ageing') : '',
                    search_approved_aging : ParamObject.get('search_approval_ageing') ?  ParamObject.get('search_approval_ageing') : '',
                    search_release_aging : ParamObject.get('search_released_ageing') ?  ParamObject.get('search_released_ageing') : '',
                    search_status_ids : status_ids
                };
                if (ParamObject.get('search_warehouse_ids')) {
                    let warehouse        =  pr.all_warehouses.find(us => us.id == ParamObject.get('search_warehouse_ids'));
                    if (warehouse) {
                        updateFilterForm['search_warehouse_ids'] = [warehouse.id];
                    }
                }
                if (ParamObject.get('tagged_user')) {
                    updateFilterForm['tagged_user_filter'] = ParamObject.get('tagged_user');
                }

                
                setTimeout(() => {
                    this.setState({
                        poSearchForm  : { ...this.state.poSearchForm, ...updateFilterForm},                      
                    },
                        function () {
                            this.submitPOSearchForm();
                        });
                }, 1000)
            }else if(ParamObject.get('search_status_ids') || ParamObject.get('search_warehouse_ids')){
                let  status_ids  =  ParamObject.get('search_status_ids').split(',').map(Number);
                let updateFilterForm = {search_status_ids : status_ids}
                if(ParamObject.get('search_warehouse_ids')) {
                 let warehouse                =   pr.all_warehouses.find(us => us.id == ParamObject.get('search_warehouse_ids'));
                 if(warehouse) {
                     updateFilterForm['search_warehouse_ids']         =   [warehouse.id];
                 }
 
              }
 
                 if (ParamObject.get('tagged_user')) {
                     updateFilterForm['tagged_user_filter'] = ParamObject.get('tagged_user');
                 }
                 setTimeout(() => {
                     this.setState({
                         poSearchForm  : { ...this.state.poSearchForm, ...updateFilterForm},                      
                     },
                         function () {
                             this.submitPOSearchForm();
                         });
                 }, 1000)
            }

        if (ParamObject.get('search_project_id')) {
            this.getProjectDetail(ParamObject.get('search_project_id'))

        }
    }
    getProjectDetail = (id) => {
        HttpAPICall.withAthorization("GET", this.projectUrl.replace('_replace_id', id), this.props.access_token, null, null, (resp) => {
            const projectDetail = resp.data.data
            if (projectDetail) {
                this.setState({
                    searchedProjects: [
                        {
                            label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                            display_label: `${projectDetail.name} (${projectDetail.transaction_id})`,
                            value: projectDetail.id
                        }
                    ],
                    poSearchForm: { ...this.state.poSearchForm, search_project_ids: [projectDetail.id] }
                }, () => {
                    this.submitPOSearchForm();
                })
            }

        })
    }
    openAddPurchaseOrderScreen       =      ()      =>     {
        this.props.history.push('/purchase_order/add')
    }

     //************************GET PO LISTING**************** */
     loadListingTblData                 =   (page = 1)  =>         {
             // Prevent only the initial fallback listing call after detail navigation.
             // Pagination clicks should always trigger API calls.
             if (this.props.location && this.props.location.state && this.props.location.state.skipListingReload && page == 1 && (!this.state.po_listing || this.state.po_listing.length === 0)) {
             console.log('loadListingTblData: skipping because skipListingReload flag present');
             try { this.props.history.replace(this.props.location.pathname, {}); } catch (e) {}
             return;
            }
            console.log("LISTING API CALLED");
        console.trace();
        this.setState({listing_loading: true, listing_tbl_page: page});
        let params                      =   {...this.state.submittedPOFilterForm, page:page};
        HttpAPICall.withAthorization('GET', this.purchaseOrderUrl, this.props.access_token, params, {}, (resp) => {
            let respData            =       resp.data;
            let listPayload         =       respData && respData.list ? respData.list : respData;
            let listingMeta         =       listPayload && listPayload.meta ? listPayload.meta : (listPayload && listPayload.current_page ? listPayload : null);
            let warehouses          =       respData && respData.warehouses && respData.warehouses.length > 0 ? respData.warehouses : [];
            let vendors             =       respData && respData.vendors && respData.vendors.length > 0 ? respData.vendors : [];
            let statusList          =       respData && respData.status && respData.status.length > 0 ? respData.status : [];
            let listingRows         =       listPayload && listPayload.data && listPayload.data.length > 0 ? listPayload.data : [];
            let normalizedListing   =       listingRows.map((row) => {
                let warehouseData   =   row.warehouse ? row.warehouse : warehouses.find((w) => Number(w.id) === Number(row.warehouse_id));
                let vendorData      =   row.vendor ? row.vendor : vendors.find((v) => String(v.id) === String(row.vendor_id));
                let statusData      =   row.status_data ? row.status_data : statusList.find((s) => Number(s.id) === Number(row.status));

                return {
                    ...row,
                    warehouse: warehouseData || null,
                    vendor: vendorData || null,
                    status_data: statusData || null,
                    transaction_date_display: row.transaction_date_display ? row.transaction_date_display : (row.transaction_date ? DateService.dateTimeFormat(row.transaction_date, 'DD-MMM-YYYY') : '-'),
                };
            });

            this.setState({
                po_listing          :       normalizedListing,
                listingMeta         :       listingMeta,
                totalListingCount   :       listingMeta && listingMeta.total ? listingMeta.total : 0,
        });
            // Save to Redux only when NOT in detail view
            if (!this.state.minimizeTable && normalizedListing && normalizedListing.length > 0) {
                this.props.setPOListState({
                    po_listing: [...normalizedListing],
                    listingMeta: listingMeta,
                    listing_tbl_page: page,
                    poSearchForm: {...this.state.poSearchForm},
                    submittedPOFilterForm: {...this.state.submittedPOFilterForm},
                    formSearchedElems: [...this.state.formSearchedElems],
                    searchedVendor: [...this.state.searchedVendor],
                    searchedItem: [...this.state.searchedItem],
                    criteriaHeight: this.state.criteriaHeight,
                    hasLoaded: true,
                    all_warehouses: [...this.state.all_warehouses],
                    all_periods: [...this.state.all_periods],
                    allStatusOptions: [...this.state.allStatusOptions],
                    isc_configuration: this.state.isc_configuration ? {...this.state.isc_configuration} : null,
                });
            }
        }).then(() => this.setState({listing_loading: false}));
    }

    submitPOSearchForm                =       (e)          =>          {
        e && e.preventDefault()
        let serachFormKeys              =   Object.keys(this.state.poSearchForm);
       
        let searchedElems               =   [];
        let searchParams                =   {};
        serachFormKeys.map((key)        =>  {
            
            let label                       =   this.poSearchFormLabel[key];
            let value                       =   this.state.poSearchForm[key];
           
            if(value && value.toString().length > 0) {
                searchParams[key]      =   value;
           if(label) {
                let show_val            =   value;
                if(key == 'tagged_user_filter') {
                    show_val            =   this.state.userFilters.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_transaction_id') {
                    show_val            =   this.state.poSearchForm ? this.state.poSearchForm.search_transaction_id : '';
                }
                if(key == 'search_vendor_ids') {
                    show_val            =   this.state.searchedVendor ? this.state.searchedVendor.map(s => s.vendor?.name).join(', ') : '';
                }
                if(key == 'search_warehouse_ids') {
                    show_val            =   this.state.all_warehouses.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_item_ids') {
                    show_val            =   this.state.searchedItem ? this.state.searchedItem.map(s => s.display_label).join(', ') : '';
                }
                if(key == 'search_item_tags') {
                    show_val            =   this.state.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }

                if(key == 'search_project_ids') {
                     show_val            =   this.state.searchedProjects ? this.state.searchedProjects.map(s => s.display_label).join(', ') : '';
                    // show_val            =  this.state.poSearchForm && this.state.poSearchForm.search_project_id ? this.state.poSearchForm.search_project_id : '';
                }

                if(key === 'search_ticket_ids') {
                    show_val            =   this.state.searchedTickets ? this.state.searchedTickets.map(s => s.value).join(', ') : '';
                }

                if(key == 'search_status_ids') {
                    show_val            =   this.state.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'search_priority') {
                    show_val            =   this.state.allPriorityOptions.filter((s) => value.includes(s.value)).map(s => s.label);
                }
                if(key == 'search_purchase_order_type') {
                    show_val            =   this.state.allPOTypes.filter((s) => value.includes(s.value)).map(s => s.label);
                }
                if(key == 'search_approved_aging') {
                    show_val            =   this.state.poSearchForm && this.state.poSearchForm.search_approved_aging ? this.state.poSearchForm.search_approved_aging  : '';
                }
                if(key == 'search_voucher_aging') {
                    show_val            =   this.state.poSearchForm && this.state.poSearchForm.search_voucher_aging ? this.state.poSearchForm.search_voucher_aging  : '';
                }
               
                if(key == 'search_release_aging') {
                    show_val            =   this.state.poSearchForm && this.state.poSearchForm.search_release_aging ? this.state.poSearchForm.search_release_aging  : '';
                }
                if(key == 'tagged_user_ids') {
                    show_val            =   this.state.allUsers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                }
                if(key == 'date_range') {
                    let  start_range         =      moment(this.state.poSearchForm.date_range_start).format('DD-MMM-YYYY');
                    let end_range            =      moment(this.state.poSearchForm.date_range_end).format('DD-MMM-YYYY')
                        let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`
                        show_val                 =     this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                searchedElems.push(label + `<b>${show_val}</b>`);

                }
            }
        });
        this.setState({
            submittedPOFilterForm       :   {...this.state.poSearchForm},
            formSearchedElems           :   searchedElems
        }, () => {
            this.poSearchModal.hide()
            this.loadListingTblData(1);
        });
    }


    poSearchClear                  =        ()             =>        {
        this.setState({
            formSearchedElems           :       [],
            poSearchForm                :       {...this.initPOSearchForm},
            submittedPOFilterForm       :       {...this.initPOSearchForm},
            searchedItem                :       [],
            searchedVendor              :       [],
            searchedProjects            :       [],

        }, () => {
            this.loadListingTblData(1);
              this.setState({
                criteriaHeight: 0
            })
            this.poSearchModal.hide();
        });
    }

    poClear                  =        ()             =>        {
        // this.setState({
        //     formSearchedElems           :       [],
        //     poSearchForm                :       {...this.initPOSearchForm},
        //     submittedPOFilterForm       :       {...this.initPOSearchForm},
        //     searchedItem                :       [],
        //     searchedVendor              :       []
        // }, () => {
        //     this.poSearchModal.hide();
        // });
    }

    //************************REQUISTION SEARCH FORM **************** */
    poSearchModalInit               =       ()             =>        {
        this.poSearchModal.show();
        this.getPOSearchFormData();
       
    }

    getPOSearchFormData             =       ()              =>      {
        if(!this.state.poSearchFormDataLoaded) {
            HttpAPICall.withAthorization('GET', this.searchFormDataUrl, this.props.access_token, null, null, (response) => {
             let formData = response.data
                this.setState({
                    poSearchFormDataLoaded  :   true,
                    allStatusOptions        :   formData && formData.status && formData.status.length > 0 ?  formData.status.map((s) => { return {value: s.id, label: s.name}; }) : [],
                    allPriorityOptions      :   formData && formData.priorities && formData.priorities.length > 0 ? formData.priorities.map((s) => { return {value: s.key, label: s.name}; }) : [],
                    allUsers                :   formData && formData.users ? formData.users.map((s) => { return {value: s.id, label: s.full_name,site_ids:s.linked_sites}; }) : [],
                    allPOTypes                :   formData && formData.purchase_order_type && formData.purchase_order_type.length > 0 ? formData.purchase_order_type.map((s) => { return {value: s.key, label: s.name}; }) : [],
                });
            });
        }
    }

    openRequistionDetails       =       ()      =>      {
        this.itemReqDetailModal.show()
     }

    viewPODetail = (transaction_id, refresh = false) => {
    // Save current listing state to Redux before navigating to detail (only if we have data)
    if (!this.isSavingToRedux) {
        this.isSavingToRedux = true;
        if (this.state.po_listing && this.state.po_listing.length > 0) {
            const stateToSave = {
                po_listing: [...this.state.po_listing],
                listingMeta: this.state.listingMeta ? { ...this.state.listingMeta } : null,
                listing_tbl_page: this.state.listing_tbl_page,
                poSearchForm: { ...this.state.poSearchForm },
                submittedPOFilterForm: { ...this.state.submittedPOFilterForm },
                formSearchedElems: [...this.state.formSearchedElems],
                searchedVendor: [...this.state.searchedVendor],
                searchedItem: [...this.state.searchedItem],
                criteriaHeight: this.state.criteriaHeight,
                hasLoaded: true,

                all_warehouses: [...this.state.all_warehouses],
                all_periods: [...this.state.all_periods],
                allStatusOptions: [...this.state.allStatusOptions],
                isc_configuration: this.state.isc_configuration ? { ...this.state.isc_configuration } : null,
            };
            this.props.setPOListState(stateToSave);
        }
        this.setState({ minimizeTable: true, poTransactionId: transaction_id }, () => {
            this.isSavingToRedux = false;
        });
    }

    // Navigate to URL with transaction_id and request the next mount to skip listing reload
    this.props.history.push({ pathname: `/purchase_order_list/${transaction_id}`, state: { skipListingReload: true } });
 }
 
    // viewPODetail = (transaction_id,refresh=false) => {
    //     console.log('clicked',transaction_id,this.state.poTransactionId)
    //     this.setState({ minimizeTable: true });
    //    // if (transaction_id !== this.state.poTransactionId || refresh==false) {
    //         console.log('clicked',transaction_id,this.state.poTransactionId)
    //         this.setState({ poTransactionId: transaction_id });
    //         console.log('clicked',transaction_id,this.state.poTransactionId)
    //         if (this.poDetailModalRef.current) {
    //             this.poDetailModalRef.current.getPODetail(transaction_id);
    //         }
    //    // }
    // }
 
    editPO              =       ()      =>      {
        this.props.history.push({ pathname: `/purchase_order/add`, state: { poData: this.state.poDetail } })
    }

    clonePO              =       ()      =>      {
        this.props.history.push({ pathname: `/purchase_order/add`, state: { clonePODetail: this.state.poDetail } })
    }

    viewItemModalInit                    =   (item)  =>  { 
        if(item){
            this.itemDetailsRef.current.modalInit(item)
        }
    }

    //***********************DOWNLOAD PDF **************************** */
    downloadPdfHandler                  =   (transaction_id, use_for = 'internal')  =>  {
        if (!transaction_id) {
            toast.error('Transaction ID not found. Please open voucher details and try again.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        this.setState({ pdfDownloading: true});
        HttpAPICall.withAthorization('GET',  this.purchaseOrderUrl + '/' + transaction_id, this.props.access_token,{download : "download", use_for : use_for},{},(response) => {
            download.file(response.data.file_path);
        })
        .then(() => this.setState({pdfDownloading: false}));
    }
    
    reportDownloadApiHandler            =   (transaction_id)  =>  {
        if (!transaction_id) {
            toast.error('Transaction ID not found. Please open voucher details and try again.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        this.setState({ pdfDownloading: true});
        HttpAPICall.withAthorization('GET', this.poReportUrl, this.props.access_token,{search_transaction_id : transaction_id, download : 'download'},{},(response) => {
            DownloadFile.file(response.data.file_path,response.data.msg,response.data.navigation,this.props)
        })
        .then(() => this.setState({pdfDownloading: false}));
    }
    
    closeViewDetails = () => {
        this.shouldRefreshList = false;

        if (!this.restorePOListFromRedux()) {
            this.setState({
                minimizeTable: false,
                poTransactionId: null,
                detail_loading: false
            });
        }

        this.props.history.replace({
            pathname: '/purchase_order_list',
            state: { preserveListState: true }
        });
    }
 
     updateComment           =           ()          =>      {
         this.myRef.current.scrollIntoView()
     }

     //*************************SUBMIT COMMENT FORM ********************** */
    submitUpdateCommentForm = (e) => {
        e.preventDefault()
        this.setState({ addCommentFormSubmitting: true })
        let frmData = {
            ...this.state.addCommentForm,
            transaction_id: this.state.poTransactionId
        }
        HttpAPICall.withAthorization('PUT', this.purchaseOrderUrl + '/comment', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.getPODetail(this.state.poTransactionId);
            this.loadListingTblData(1)
            this.setState({ addCommentForm: { ...this.updateCommentFormInit } })
        }).then(() => this.setState({ addCommentFormSubmitting: false }));
    }

    //*************************CANCEL ITEM PO ***** ********************** */
    checkAllCancelItem() {
        let poItemCollections = document.getElementsByClassName('po_item_id_checkbox')
        if (poItemCollections && poItemCollections.length > 0) {
            for (let i = 0; i < poItemCollections.length; i++) {
                poItemCollections[i].checked = document.getElementById('all_check_po').checked;
            }
        }

    }


    vendorDetailModalInit = (id) => {
        this.VendorDetailModalRef.current.modalInit(id)
    }

    cancelPOItem = () => {
    if (this.poDetailModalRef.current) {
        this.poDetailModalRef.current.cancelPOItem();
    }
}

    addPurchaseHandler = () => {
        const { poDetail } = this.state;

        if (!poDetail) {
            toast.error('No purchase order selected', {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        let po_item_ids = [];
        let pendingQtyList = [];
        let selectedItems = [];
        let poItemCollections = document.getElementsByClassName('po_item_id_checkbox');

        if (poItemCollections && poItemCollections.length > 0) {
            for (let i = 0; i < poItemCollections.length; i++) {
                if (poItemCollections[i].checked) {
                    let itemId = poItemCollections[i].value;
                    let poItemId = poItemCollections[i].getAttribute("data-poItemId");
                    let pendingQty = poItemCollections[i].getAttribute("data-pendingQty");

                    po_item_ids.push(poItemId);
                    pendingQtyList.push(pendingQty);

                    let itemData = poDetail.items.find(
                        row => row.item.id == itemId
                    );

                    if (itemData && Number(itemData.pending_qty) > 0) {
                        selectedItems.push({
                            ...itemData,
                            po_item_id: poItemId,
                            pending_qty: pendingQty
                        });
                    }
                }
            }
        }

        if (selectedItems.length === 0) {
            toast.error('Please select at least one Item with pending quantity > 0', {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        if (po_item_ids.length == 0) {
            toast.error('Please select at least one Item', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (pendingQtyList.includes('0')) {
            toast.error('Every item must have pending qty more than 0', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        let poStateData = {
            warehouse_id: poDetail.warehouse_id,
            vendor_id: poDetail.vendor?.id,
            vendor_name: poDetail.vendor?.name,
            currency: poDetail.currency || "INR",
            conversion_rate: poDetail.conversion_rate || 1,
            notes: poDetail.notes || "",
            transaction_id: poDetail.transaction_id,
            po_item_ids: po_item_ids, // Add PO item IDs
            pending_qty_list: pendingQtyList, // Add pending quantity list
            // Send the items with po_item_id and pending_qty
            items: selectedItems.map(item => ({
                id: item.item.id,
                po_item_id: item.po_item_id,
                pending_qty: item.pending_qty,
                qty: item.qty,
                rate_vc: item.rate_vc,
                // Include other item details as needed
            }))
        };

        this.props.history.push({
            pathname: "/purchase_list/add",
            state: {
                addPurchaseFromPO: poStateData
            }
        });
    }

     updateComment = () => {
        // Call the detail component's scroll to comment method
        if (this.poDetailModalRef.current) {
            this.poDetailModalRef.current.scrollToComment();
        }
    }

   
   

    purchaseOrderListJsx            =       ()      =>    {
        const activePOTransactionId = this.getActivePOTransactionId();
        return (<Ax><div className="page_title row m0">
            <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                <h3>Purchase Order</h3>
                <div className="text-end mt15">
                    {(!this.state.minimizeTable) ? <button type="button"   disabled={!this.props.permissions.includes('isc-po-add')} className="btn btn-primary" onClick={this.openAddPurchaseOrderScreen}>New PO</button> : null}
                    {(!this.state.minimizeTable) ? <button type="button" className="btn btn-secondary" onClick={this.poSearchModalInit} disabled={this.state.listing_loading} >
                        <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                    </button> : null}
                    {this.state.minimizeTable && this.props.permissions.includes('isc-po-add') ?
                        <span className="dropdown">
                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                {this.state.minimizeTable ? <li><a className="dropdown-item" href="#" onClick={this.openAddPurchaseOrderScreen}>Add </a></li> : null}
                            </ul>
                        </span> : null}
                </div>
            </div>
            {
                this.state.minimizeTable
                    ? (
                        <div className="col-9 tap_border_left">
                            <h3>{this.state.poDetail && this.state.poDetail.title ? this.state.poDetail.title : ""} </h3>
                            <div className="text-end mt15">
                             <button 
                                type="button"
                                className="btn btn-secondary" 
                                disabled={this.state.detail_loading || this.state?.poDetail?.status == 6 || this.state?.poDetail?.status == 7||  this.state?.poDetail?.status == 5} 
                                onClick={() => this.updateComment()} >Update Status </button>
                                 <button 
                                type="button"
                                className="btn btn-secondary" 
                                disabled={(this.state.detail_loading) || (this.state?.poDetail?.status !== 4 && this.state?.poDetail?.status !== 5) || !this.props.permissions.includes('isc-purchase-add')} 
                                onClick={() => this.addPurchaseHandler()} >Add to Purchase </button>
                            <button 
                                disabled={this.state.pdfDownloading || this.state.detail_loading || !activePOTransactionId}
                                type="button" data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                                {this.state.pdfDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />) : ''}
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <Link className="dropdown-item" disabled={this.state.detail_loading} onClick={() => this.downloadPdfHandler(activePOTransactionId, 'internal')}>PDF for Internal Use</Link>
                                </li>
                                <li>
                                    <Link className={['dropdown-item', (this.state.detail_loading || this.state?.poDetail?.status < 4 || this.state?.poDetail?.status == 6) ? 'disabled' : ''].join(' ')} href="#"  onClick={() => this.downloadPdfHandler(activePOTransactionId, 'vendor')}>PDF for Vendor</Link>
                                </li>
                                <li>
                                    <Link className={['dropdown-item', (this.state.detail_loading || this.state?.poDetail?.status < 4) ? 'disabled' : ''].join(' ')} href="#"  onClick={() => this.reportDownloadApiHandler(activePOTransactionId)}>Item-Wise Report</Link>
                                </li>
                            </ul>
                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li>
                                    <a href='#' className={['dropdown-item', (this.state.detail_loading || this.state.poDetail?.can_edit == "N" || !this.props.permissions.includes('isc-po-edit')) ? 'disabled' : ''].join(' ')} onClick={() => this.editPO(this.state.poTransactionId)}>Edit</a>
                                </li>
                                <li>
                                    <a href='#' className={['dropdown-item', (this.state.detail_loading) ? 'disabled' : ''].join(' ')} onClick={() => this.clonePO()}>Clone</a>
                                </li>
                                <li>
                                    <a 
                                        href='#' 
                                        className={['dropdown-item', (this.state.detail_loading) || !this.props.permissions.includes('isc-po-cancel_item') ? 'disabled' : ''].join(' ')} 
                                        onClick={() => {
                                            this.setState({cancelledItemList : []}, () => {
                                                this.cancelPOItem(this.state.poTransactionId)
                                            })}}
                                        >Cancel Item</a>
                                </li>
                           </ul>
                                <button type="button" className="btn btn-secondary" onClick={this.closeViewDetails}>
                                    <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    )
                    : null
            }
        </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-3' : 'col-12'].join(' ')} >{this.purchaseOrderListingJsx()}</div>
                    {this.state.minimizeTable ? <div className="col-9 pr4 pl4 pageTbl bg-white">{this.purchaseOrderViewDetails()}</div> : null}
                </div>
            </div>
        </Ax>);
    }

    purchaseOrderListingJsx            =   ()   =>   {
        return(<Ax>
             <div ref={this.criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
          <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.poSearchClear} />
          </div>
            <table className="table table-bordered  bg-white">
                <thead className="table-secondary"style={{top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}  >
                { this.state.minimizeTable
                    ? (<tr>
                        <th scope="col" style={{width:"15%"}}>Transaction ID (Date)</th>
                    </tr> )
                    :   ( <tr className="text-center">
                        <th scope="col" style={{width:"5%"}}>S.No</th>
                        <th scope="col" style={{width:"12%"}}>PO Number</th>
                        <th scope="col" style={{width:"12%"}}> Date</th>
                        <th scope="col" style={{width:"18%"}}>Warehouse</th>
                        <th scope="col" style={{width:"18%"}}>Vendor Name</th>
                        <th scope="col" style={{width:"6%"}}>Quantity</th>
                        <th scope="col" style={{width:"6%"}}>Currency</th>
                        <th scope="col" style={{width:"10%"}} className="text-end">Amount</th>
                        <th scope="col" style={{width:"10%"}}>Status</th>
                        <th scope="col" style={{width:"5%"}}>Action</th>
                    </tr> )
                }
                </thead>
                <tbody>
                    {this.state.listing_loading
                        ? (<tr><td colSpan="9"><Loader /></td></tr>)
                        : (this.state.po_listing.length > 0
                            ? (this.state.po_listing.map((item, index) => {
                                return (<tr key={index} >
                                    {
                                        this.state.minimizeTable
                                            ? (
                                                <Ax>
                                                    <td>
                                                        <a role="button" className="link-primary" onClick={() => this.viewPODetail(item.transaction_id)}>{item.transaction_id}</a>
                                                        <br /><small>{item.transaction_date_display}</small>
                                                        <small style={{ float: 'right' }}>{item.status_data ? item.status_data.name : ''}</small>
                                                    </td>
                                                </Ax>
                                            )
                                            : (<Ax>
                                                <td>{this.state.listingMeta ? this.state.listingMeta.from + index : index} </td>
                                                <td><a role="button" className="link-primary text-center" onClick={() => this.viewPODetail(item.transaction_id)}>{item.transaction_id}</a></td>
                                                <td>{item.transaction_date_display}</td>
                                                <td>{item.warehouse ? item.warehouse.name : '-'}</td>
                                                <td className='text-capitalize'>{item.vendor ? <div>{item.vendor.name}</div>
                                                    : "-"}</td>

                                                <td className="text-end">{parseFloat(item.total_qty)}</td>
                                                <td className="text-center">{item.currency ? item.currency : "INR"}</td>
                                                <td className="text-end"><CurrencyFormatter currencyCode={item.currency ? item.currency : "INR"} amount={parseFloat(item.total_amount_vc ? item.total_amount_vc : 0).toFixed(2)} />
                                                    
                                                    </td>
                                                <td className='text-center'>{item.status_data ? item.status_data.name : '-'}</td>
                                                <td className="text-center">
                                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                                        <tapIcon.FontAwesomeIcon icon={tapIcon.faEllipsisV} />
                                                    </button>
                                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                        <li><a className="dropdown-item" role="button">View</a></li>
                                                    </ul>
                                                </td>
                                            </Ax>
                                            )}
                                </tr>)
                            }))
                            : (<tr><td colSpan="10" className="text-center">No Records</td></tr>)
                        )
                    }
                </tbody>
            </table>
            <DisplayListPagination
                meta={this.state.listingMeta}
                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
            />
        </Ax>)
    }


    handlePODetailLoaded = (data) => {
        this.setState({
            poDetail: data,
            poTransactionId: data?.transaction_id || this.state.poTransactionId
        });
    }

    handlePOUpdated = (id) => {
        this.loadListingTblData(this.state.listing_tbl_page);
        this.viewPODetail(id,true)
    }

    purchaseOrderViewDetails                =   ()   =>   {
      

        return (<div className='p-2'>
            <PurchaseOrderDetailModal
                ref={this.poDetailModalRef}
                renderAs="inline"
                transaction_id={this.state.poTransactionId}
                onDetailLoaded={this.handlePODetailLoaded}
                onUpdate={(id) => this.handlePOUpdated(id)}
            />


        </div>)
    }

     //***********************SEARCH REQUISTION JSX****************
     poSearchModalJsx               =        ()             =>        {
        return (
            <div className="modal fade" id="poSearchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">PO Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.poClear}></button>
                        </div>
                        <form id="poSearchForm" onSubmit={this.submitPOSearchForm}>
                            <div className="modal-body">
                                {!this.state.poSearchFormDataLoaded ? <Loader />
                                    : <Ax>
                                        <div className="row my-3 align-items-center">
                                           
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">PO Number</label>
                                            <div className="col-sm-4">
                                                <input
                                                    name="search_transaction_id"
                                                    type="text"
                                                    value={this.state.poSearchForm.search_transaction_id}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "poSearchForm")}
                                                    placeholder="Please enter Transaction ID"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">PO Type</label>
                                            <div className="col-sm-4">
                                            <TapSelect
                                                    options={this.state.allPOTypes}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'search_purchase_order_type')}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    value={this.state.allPOTypes.find(s => this.state.poSearchForm.search_purchase_order_type == s.value)}
                                                    placeholder="Select PO Type"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>

                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Status</label>
                                            <div className="col-sm-4">
                                                <TapSelect
                                                    options={this.state.allStatusOptions}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'search_status_ids')}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}

                                                    value={this.state.allStatusOptions.filter(s => this.state.poSearchForm.search_status_ids.includes(s.value))}
                                                    placeholder="Select Status"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Priority</label>
                                            <div className="col-sm-4">
                                                <TapSelect
                                                    options={this.state.allPriorityOptions}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'search_priority')}
                                                    value={this.state.allPriorityOptions.find(u => u.value == this.state.poSearchForm.search_priority)}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="Select Priority"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>


                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Warehouse</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.all_warehouses}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'search_warehouse_ids')}
                                                    value={this.state.all_warehouses.filter(u => this.state.poSearchForm?.search_warehouse_ids?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Warehouses"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm ">Vendor</label>
                                            <div className="col-sm-10">
                                                <InputVendorSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'poSearchForm', 'search_vendor_ids');
                                                        this.setState({ searchedVendor: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    isMulti={true}
                                                    value={this.state.searchedVendor.length > 0 ? this.state.searchedVendor.map(a => { a.label = a.display_label; return a; }) : []}
                                                    containerHeight="30px"
                                                    fontSize="93%"

                                                />
                                            </div>

                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm ">Item</label>
                                            <div className="col-sm-10">
                                                <InputItemSearch
                                                    placeholder="Search Item"
                                                    isMulti={true}
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'poSearchForm', 'search_item_ids');
                                                        this.setState({
                                                            searchedItem: selectedOption ? selectedOption : null
                                                        }, () => { });
                                                    }}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state.searchedItem.length > 0 ? this.state.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                                                />
                                            </div>

                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Item Tags</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    options={this.state.allItemTags}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'search_item_tags')}
                                                    value={this.state.allItemTags.filter(u => this.state.poSearchForm?.search_item_tags?.includes(u.value))}
                                                    isSearchable={true}
                                                    isMulti={true}
                                                    isClearable={true}
                                                    placeholder="Select Item Tags"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Tag Category</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="All"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    options={this.state.userFilters}
                                                    value={this.state.userFilters.find(r => r.value === this.state.poSearchForm.tagged_user_filter)}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'tagged_user_filter')}
                                                />
                                            </div>
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Tagged User</label>
                                            <div className="col-sm-10">
                                                <TapSelect
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    isMulti={true}
                                                    placeholder="Tagged User"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    options={this.state.allUsers}
                                                    value={this.state.allUsers.filter(s => this.state.poSearchForm.tagged_user_ids.includes(s.value))}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'poSearchForm', 'tagged_user_ids')}
                                                />
                                            </div>
                                        </div>

                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Ticket</label>
                                            <div className="col-sm-10">
                                                <InputTicketSearch
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'poSearchForm', 'search_ticket_ids');
                                                        this.setState({ searchedTickets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    isMulti={true}
                                                    menuPlacement="top"
                                                    value={this.state.searchedTickets.length > 0 ? this.state.searchedTickets.map(a => { a.label = a.display_label; return a; }) : []}
                                                    search_exclude_ticket_status={[0,26, 10]}
                                                />
                                            </div>
                                        </div>

                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm">Project</label>
                                            <div className="col-sm-10">
                                                <InputProjectSearch
                                                    changeEvent={(selectedOption) => {
                                                        this.tapSelectChange(selectedOption, 'poSearchForm', 'search_project_ids');
                                                        this.setState({ searchedProjects: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                                    }}
                                                    placeholder="Search Project"
                                                    isMulti={true}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    value={this.state.searchedProjects.length > 0 ? this.state.searchedProjects.map(a => { a.label = a.display_label; return a; }) : []} />
                                                {/* <input
                                                    type="text"
                                                    name="search_project_id"
                                                    className="form-control form-control-sm"
                                                    placeholder="Project"
                                                    autoComplete="off"
                                                    value={this.state.poSearchForm.search_project_id}
                                                    onChange={(e) => this.formInputHandler(e, "poSearchForm")}
                                                /> */}
                                            </div>
                                        </div>

                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Voucher Ageing</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_voucher_aging"
                                                    type="text"
                                                    value={this.state.poSearchForm.search_voucher_aging}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "poSearchForm")}
                                                    placeholder="Example. 0-5 for a range or 4 for Voucher Ageing"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>
                                            
                                        </div>
                                        <div className="row my-3 align-items-center">
                                            
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Approval Ageing</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_approved_aging"
                                                    type="text"
                                                    value={this.state.poSearchForm.search_approved_aging}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "poSearchForm")}
                                                    placeholder="Example. 0-5 for a range or 4 for Approval Ageing"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>


                                        </div>
                                        <div className="row my-3 align-items-center">
                                            
                                            <label className="col-sm-2 col-form-label col-form-label-sm  ">Released Ageing</label>
                                            <div className="col-sm-10">
                                                <input
                                                    name="search_release_aging"
                                                    type="text"
                                                    value={this.state.poSearchForm.search_release_aging}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "poSearchForm")}
                                                    placeholder="Example. 0-5 for a range or 4 for Released Ageing"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>


                                        </div>
                                        <div className="row my-3 align-items-center">
                                            <label className="col-sm-2 col-form-label col-form-label-sm ">Transaction Period</label>
                                            <div className="col-sm-10">
                                                <PeriodSelectionWithCustom
                                                    periods={this.state.all_periods ? this.state.all_periods : []}
                                                    value={this.state.poSearchForm.date_range}
                                                    startDate={this.state.poSearchForm.date_range_start}
                                                    endDate={this.state.poSearchForm.date_range_end}
                                                    onSelectPeriod={(period, startDate, endDate) => {
                                                        this.setState({
                                                            poSearchForm
                                                                : {
                                                                ...this.state.poSearchForm,
                                                                date_range: period,
                                                                date_range_start: startDate ? startDate : null,
                                                                date_range_end: endDate ? endDate : null
                                                            }
                                                        });
                                                    }}
                                                    className="form-control-sm"
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                    </Ax>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.poClear}>Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
   }


    render                              =   ()  =>  {
        return (<ApplicationLayout>
         <Helmet><title>Purchase Order Listing</title></Helmet>
            {this.purchaseOrderListJsx()}
            {this.poSearchModalJsx()} 
           
        </ApplicationLayout>);
    }

}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        all_periods             :   state.app && state.app.all_periods ? state.app.all_periods : [],
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        item_tags               :   state.app && state.app.item_tags ? state.app.item_tags : [],
        orgInfoData             :   state.app.group_info ? state.app.group_info : null,
        default_currency        :   state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],
        settings                :   state.app.setting
    };
};

const mapDispatchToProps = {
    setPOListState,
    clearPOListState
};

const mergedMapStateToProps = (state) => ({
    ...mapStateToProps(state),
    purchaseOrderListState: state.purchaseOrderListState
});

export default connect(mergedMapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PurchaseOrderList);